import { adminWorkspaceQueryKeys as e } from "./adminWorkspaceQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { workspaceAdminApi as n } from "@maat/api-main";
//#region src/workspaces/admin/useAdminWorkspacePropertiesQuery.ts
var r = (r, i) => t({
	queryKey: e.properties(r, i),
	fetchPage: (e) => n.listProperties(r, {
		...i,
		page: e
	}),
	enabled: !!r,
	key: "properties"
});
//#endregion
export { r as useAdminWorkspacePropertiesQuery };
